export default import.meta.ROLLDOWN_FILE_URL_KslwvlBm$wDvsDwYBKZI1g